<template>
	<section class="hero">
		<div class="hero__inner">
			<div class="hero__bg hero__bg_1 _ibg-contain">
				<img src="@/assets/images/bg/hero/01.png" />
			</div>
			<div class="hero__bg hero__bg_2 _ibg-contain">
				<img src="@/assets/images/bg/hero/02.png" />
			</div>
			<div class="hero__contet">
				<div class="hero__top">
					<div class="hero__title hero__title_right _h1">
						{{ $t('Where Precision') }}
					</div>
					<div class="hero__title hero__title_left _h1">
						{{ $t(' Meets Prestige') }}
					</div>
				</div>
				<div class="hero__text _text-secondary">
					<span>
						{{
							$t(
								'Unleash your power with skins that define your aim and your legacy.'
							)
						}}
					</span>
					<span>
						{{
							$t(
								' At SkinEagle, we turn your inventory into a statement — bold, sharp, unforgettable.'
							)
						}}
					</span>
				</div>
				<BaseButton
					@click="handleShopNowClick"
					class="hero__button _btn-primary"
					>{{ $t('Buy skins') }}
				</BaseButton>
				<div class="hero__scroll-info _md">
					{{ $t('Stand out. Strike true. Own every round.') }}
				</div>
				<div class="hero__scroll">
					<svg
						width="20"
						height="26"
						viewBox="0 0 20 26"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9.75 0.999979V24.3333M9.75 24.3333L18.5 15.5833M9.75 24.3333L1 15.5833"
							stroke="white"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import { mapActions, mapState } from 'vuex';

export default {
	name: 'HeaderComponent',
	components: { BaseButton },
	props: {},
	data() {
		return {};
	},
	computed: {
		...mapState('app', ['currency']),
	},
	methods: {
		...mapActions('app', ['changeLocale', 'changeCurrency']),
		handleShopNowClick() {
			this.$router.push('/products/all');
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.hero {
	&__inner {
		position: relative;
		min-height: calc(100vh - 98px);
		@media (max-width: $md1) {
			min-height: calc(100vh - 70px);
		}
		@media (max-width: $md4) {
			min-height: calc(100vh - 50px);
		}
		display: flex;
		align-items: center;
		@include adaptiveValue('padding-top', 50, 25);
		@include adaptiveValue('padding-bottom', 50, 25);
	}
	&__bg {
		position: absolute;
		//pointer-events: none;
		z-index: 1;
		@media (max-width: $md2) {
			@include hide-item;
		}
		&_1 {
			top: 50%;
			left: 0px;
			transform: translate(5%, -49%);
			@include adaptiveValue('width', 382, 300, 1920, 1470, 1);
			padding-bottom: 43%;
			@media (max-width: $md1) {
				transform: translate(0%, -73%);
				padding-bottom: 32%;
				@include adaptiveValue('width', 300, 160, 1470, 992, 1);
			}
		}
		&_2 {
			top: 50%;
			right: 0px;
			transform: translate(12%, -49%);
			@include adaptiveValue('width', 490, 400, 1920, 1470, 1);
			padding-bottom: 44.5%;
			@media (max-width: $md1) {
				transform: translate(48%, -65%);
				padding-bottom: 41%;
				@include adaptiveValue('width', 400, 250, 1920, 1470, 1);
			}
		}
	}
	&__contet {
		flex: 1 1 100%;
		max-width: 880px;
		margin: 0 auto;
	}
	&__top {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 33, 20);
		}
	}
	&__title {
		position: relative;
		display: block;
		width: fit-content;
		margin-left: auto;
		margin-right: auto;
		&::before,
		&::after {
			content: '';
			position: absolute;
			top: 50%;
			width: 100%;
			@include adaptiveValue('height', 64, 22);
			background-image: url('@/assets/images/bg/title-bg.png');
			background-repeat: no-repeat;
			background-position: center;
			background-size: contain;
			background-size: 100% 100%;
			@media (max-width: $md3) {
				@include hide-item;
			}
		}
		&_right {
			&::before {
				display: none;
			}
			&::after {
				right: -100%;
				transform: translate(-6px, -40%);
			}
		}
		&_left {
			&::before {
				display: none;
			}
			&::after {
				left: -100%;
				transform: rotate(180deg) translate(-6px, 40%);
			}
		}
	}
	&__text {
		display: flex;
		flex-direction: column;
		align-items: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 90, 20);
		}
	}
	&__button {
		@include adaptiveValue('font-size', 24, 16);
		max-width: 426px;
		width: 100%;
		margin-left: auto;
		margin-right: auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 105, 20);
		}
	}
	&__scroll-info {
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 45, 20);
		}
	}
	&__scroll {
		display: block;
		width: fit-content;
		margin-left: auto;
		margin-right: auto;
	}
}
</style>
